module.exports = __webpack_public_path__ + "img/Image3.0b061c03.png";